export const awayFirstSports = (sport: string): boolean =>
  ["American Football", "Basketball", "Baseball", "Ice Hockey"].includes(sport);

export function orderedCompetitorData<T>(
  data: { home: T; draw?: T; away: T },
  sport: string
): T[] {
  const dataArray: T[] = [];

  dataArray.push(!awayFirstSports(sport) ? data.home : data.away);

  if (data.draw) {
    dataArray.push(data.draw);
  }

  dataArray.push(!awayFirstSports(sport) ? data.away : data.home);

  return dataArray;
}
